<template>
  <nav
    class="navbar"
    :class="{ 'navbar-expand-lg bg-secondary nav-border': isLoggedIn }"
  >
    <a class="navbar-brand" href="">
      <img src="../../assets/img/apix_white.png" />
    </a>
    <button
      v-if="isLoggedIn"
      class="navbar-toggler text-secondary_2"
      type="button"
      @click="toggleShow = !toggleShow"
    >
      <span class="fa fa-2x fa-bars text-secondary_2"></span>
    </button>
    <div
      v-if="isLoggedIn"
      :class="{ show: toggleShow }"
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" to="/suppliers">{{
            $t("common.suppliers")
          }}</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/letters">{{
            $t("common.letters")
          }}</router-link>
        </li>
      </ul>
      <locale-selector></locale-selector>

      <a href="#" class="nav-link" @click="logout">{{ $t("common.logout") }}</a>
    </div>
    <locale-selector v-if="!isLoggedIn"></locale-selector>
  </nav>
</template>
<script>
import LocaleSelector from "../common/LocaleSelector.vue";
export default {
  props: ["isLoggedIn"],
  data() {
    return {
      toggleShow: false,
    };
  },
  methods: {
    logout: function () {
      this.$store.dispatch("deleteSession");
      this.$router.push({ name: "login" });
    },
  },
  components: {
    LocaleSelector,
  },
};
</script>

<style scoped>
.nav-border {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.15);
}
.navbar-brand > img{
  width: 137px;
}
.navbar-nav {
  margin-right: auto;
  margin-left: auto;
  position: relative;
  left: 30px;
  font-size: 20px;
}
.router-link-exact-active {
  border-bottom: solid 3px rgb(255, 115, 0) !important;
}
@media screen and (max-width: 768px) {
  .navbar-nav {
    left: 0;
  }
}
</style>